import React from 'react';
import { T } from '../tokens';

export const STATUS = {
  open: { bg: T.warningBg, fg: T.warningFg, label: 'Åben' },
  approved: { bg: T.successBg, fg: T.accent, label: 'Godkendt' },
  rejected: { bg: T.errorBg, fg: T.error, label: 'Afvist' },
  pending: { bg: T.warningBg, fg: T.warningFg, label: 'Afventer' },
  cancelled: { bg: T.track, fg: T.fg3, label: 'Annulleret' },
  awaiting_credit: { bg: T.infoBg, fg: T.info, label: 'Afventer kredit' },
} as const;

export type StatusKey = keyof typeof STATUS;

export interface BadgeProps {
  children?: React.ReactNode;
  tone?: 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'accent';
  dot?: boolean;
  style?: React.CSSProperties;
}

export function Badge({ children, tone = 'neutral', dot, style = {} }: BadgeProps) {
  const tones: Record<NonNullable<BadgeProps['tone']>, { bg: string; fg: string }> = {
    neutral: { bg: T.track, fg: T.fg2 },
    success: { bg: T.successBg, fg: T.accent },
    warning: { bg: T.warningBg, fg: T.warningFg },
    danger: { bg: T.errorBg, fg: T.error },
    info: { bg: T.infoBg, fg: T.info },
    accent: { bg: T.accentLight, fg: T.accent },
  };
  const c = tones[tone] || tones.neutral;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 5,
      padding: '3px 10px', borderRadius: 999,
      fontSize: 11.5, fontWeight: 700,
      background: c.bg, color: c.fg,
      ...style,
    }}>
      {dot && <span style={{ width: 6, height: 6, borderRadius: 999, background: c.fg }} />}
      {children}
    </span>
  );
}

export interface StatusBadgeProps {
  status: StatusKey;
  style?: React.CSSProperties;
}

export function StatusBadge({ status, style }: StatusBadgeProps) {
  const s = STATUS[status] || STATUS.open;
  return (
    <Badge style={{ background: s.bg, color: s.fg, ...style }} dot>
      <span style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap', border: 0 }}>Status: </span>
      {s.label}
    </Badge>
  );
}
